import React from "react";
import { NavLink } from "react-router-dom";
import { withRouter } from "react-router";

import HeroSection from "../sections/HeroSection/HeroSection";
import OneLineSection from "../sections/OneLineSection/OneLineSection";
import FullImageSection from "../sections/FullImageSection/FullImageSection";
import DescriptionSection from "../sections/DescriptionSection/DescriptionSection";
import AddressAllegroSection from "../sections/AddressAllegroSection/AddressAllegroSection";

import { realizacjeProdukt } from "../config";

const RealizacjeProdukt = (props) => {

  const {id} = props.match.params;

  const {
      title, content, views
  } = realizacjeProdukt[id];

  return (
    <React.Fragment>
      {console.log(realizacjeProdukt)}
      <HeroSection image="../assets/realizacje_banner.jpg" />
      <OneLineSection
        title={title}
        theme="black"
        content={content()}
      />
      {views.map(element => <FullImageSection image={element} />)}
      <DescriptionSection
        imageButton="../assets/etykiety-link.png"
        imageLink="/poligrafia#wydruk-etykiet"
      >
        <NavLink to="/realizacje">
          <img
            className="image-button"
            alt=""
            src="../assets/galeria-link.png"
          />
        </NavLink>
      </DescriptionSection>
      <AddressAllegroSection />
    </React.Fragment>
  );
};

export default withRouter(RealizacjeProdukt);
